import { useSelector } from 'react-redux';
import type { BreadcrumbLink } from '@noths/polaris-design-system-candidate-components';

import { adaptTaxonomyContextToBreadcrumbs } from 'src/adapters/storeToUI/adaptTaxonomyContextToBreadcrumbs';
import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { selectMatchedTaxonomyEntry } from 'src/redux/content/selectors/selectMatchedTaxonomyEntry';
import { selectTaxonomyContext } from 'src/redux/productsQuery/selectors/selectTaxonomyContext';

/**
 * The taxonomy PLP breadcrumb trail. Shared by the rendered breadcrumbs and the
 * page's `BreadcrumbList` JSON-LD so the two can never drift, and computed in a
 * hook so both stay correct across client-side neighbourhood transitions.
 */
export const useTaxonomyBreadcrumbs = (): BreadcrumbLink[] => {
  const context = useSelector((state: ReduxApplicationState) => selectTaxonomyContext(state));
  const matchedEntry = useSelector(selectMatchedTaxonomyEntry);

  return adaptTaxonomyContextToBreadcrumbs(context, matchedEntry);
};
